<script setup lang="ts">
import type { SidebarProps } from '@/components/shadcn-ui/sidebar'
import NavMain from '@/components/navigation/NavMain.vue'
import NavUser from '@/components/navigation/NavUser.vue'
import { useNavigation } from '@/composables/useNavigation'

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/shadcn-ui/sidebar'

const props = withDefaults(defineProps<SidebarProps>(), {
  collapsible: 'icon',
})

const { navItems } = useNavigation()

// TODO: Replace with actual user data from auth store
const userData = {
  name: 'Usuario Demo',
  email: 'demo@syntaxis.com',
  avatar: '/avatars/user.jpg',
}
</script>

<template>
  <Sidebar v-bind="props">
    <SidebarHeader>
      <img src="../../assets/images/logo.svg" alt="Syntaxis" class="w-40" />
    </SidebarHeader>
    <SidebarContent>
      <NavMain :items="navItems" />
    </SidebarContent>
    <SidebarFooter>
      <NavUser :user="userData" />
    </SidebarFooter>
    <SidebarRail />
  </Sidebar>
</template>
